import React from 'react';
import styled from 'styled-components';
import ReserverNowPayLater from '../assets/hotels/details/reserve-now-pay-later.svg';

const ReserverNowPayLaterIcon = styled(
  ReserverNowPayLater as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  /* cursor: pointer; */
`;

export default ReserverNowPayLaterIcon;
